import type { RouterInputs, RouterOutputs } from '@shared/all/domains/trpc';

// Single source of truth: the passkey ceremony JSON shapes come straight from
// the server router's tRPC types, so web + native helpers stay in lockstep with
// what the server generates and verifies.
export type PasskeyRegisterOptions =
  RouterOutputs['auth']['passkey']['registerOptions']['options'];
export type PasskeyAuthOptions =
  RouterOutputs['auth']['passkey']['authOptions']['options'];
export type PasskeyRegisterResponse =
  RouterInputs['auth']['passkey']['registerVerify']['response'];
export type PasskeyAuthResponse =
  RouterInputs['auth']['passkey']['authVerify']['response'];

// Thrown when the user dismisses the OS passkey sheet. Callers treat this as a
// quiet no-op rather than an error toast.
export class PasskeyCancelledError extends Error {
  constructor() {
    super('Passkey prompt was cancelled.');
    this.name = 'PasskeyCancelledError';
  }
}
